const API_BASE = 'https://api.dev.auxo.dk/public'

/**
 * Fetch all entries in a CMS collection (v2 with pagination and filters)
 */
export async function fetchCollectionV2(collectionName, params = {}) {
  try {
    const url = new URL(`${API_BASE}/v2/content/${collectionName}`)
    Object.entries(params).forEach(([key, val]) => {
      if (val !== undefined && val !== null && val !== '') {
        url.searchParams.append(key, val)
      }
    })
    const res = await fetch(url.toString())
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return await res.json()
  } catch (err) {
    console.warn(`CMS fetch failed for ${collectionName}:`, err)
    return { items: [], total: 0 }
  }
}

/**
 * Fetch all entries as bare array
 */
export async function fetchCollectionList(collectionName) {
  try {
    const res = await fetch(`${API_BASE}/content/${collectionName}`)
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return await res.json()
  } catch (err) {
    console.warn(`CMS list failed for ${collectionName}:`, err)
    return []
  }
}

/**
 * Fetch a single entry by slug
 */
export async function fetchBySlug(slug) {
  try {
    const res = await fetch(`${API_BASE}/by-slug/${slug}`)
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return await res.json()
  } catch (err) {
    console.warn(`CMS by-slug failed for ${slug}:`, err)
    return null
  }
}
